export default "__VITE_ASSET__34c07242__"